export default __webpack_public_path__ + "static/media/project-tf.090fb032.png";